<div class="fs-2 with-close" mat-dialog-title>
    Information GES
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
    <img src="assets/ges.avif" />
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline w-100">
        Fermer
    </button>
</div>
